<template>
    <form-row title="Insurance Company" :label_align_top="true" class="mt-4">
        <div class="w-full">
            <input-text
                class="-mt-4"
                name="insurance_company"
                :value="insurance.insurance_company"
                label="Company"
                placeholder="Company"
                :read_only="read_only"
            />

            <div class="mt-4">
                <contact-selector
                    name_prefix="agent"
                    :available_contacts="available_contacts"
                    contact_type="broker_contact"
                    :value="{
                        contact_id: insurance.contact_id,
                        name: insurance.agent_name,
                        email: insurance.agent_email,
                        phone: insurance.agent_phone,
                    }"
                    name_label="Agent Name"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
import ContactSelector from '../../components/contact-selector.vue';

export default {
    components: {
        ContactSelector,
    },

    props: {
        insurance: {},
        available_contacts: { default: () => [] },
        read_only: { default: false },
    },
}
</script>
